import {
    getQueryString,
    invokeApp,
    setStorage,
    getStorage,
    clearStorage,
    removeStorage,
} from "@/util";
var lang = getStorage('lang') || 'zh'
const version = '1.0.0'
console.log('version', version)
const languages = {
    'zh': '中文',
	'ug':'ئۇيغۇرچە',
	// 'de': '德语',
	// 'it': '意大利语',
	// 'id': '印尼语',
	// 'pt': '葡萄牙语',
    // 'en': 'English',
    // 'vi': 'Tiếng Việt',
    // 'ko': '한국어',
    // 'ru': 'Русский',
    // 'ja': '日本語',
    // 'th': 'ภาษาไทย',
    // 'fr': 'français',
    // 'es': 'Español',
}
const os = 'H5'
const accessToken = getStorage('access_token') || null
const inWechat = false
const inApp = false
const changeLang = false
const appversion = null
const userInfo = {
    avatar: null
}
const logoUrl = 'https://www.hskonline.com/logo80.png'
const cdnUrl = 'http://akm.hskcdn.com'
const ossUrl = 'http://akm.hskcdn.com/sc'
const apis = {
	"comments":"m/vip/evaluation",
	"product": "m/order/product",
    "order": "m/proxy/buy",
    "return": window.location.origin + window.location.pathname + "#/result",
	"privacy":"app/privacy",
	"protocol":"app/protocol",
	"autopay":"app/autopay",
	"product":"proxy/price",
	"browse":"proxy/browse",
	"userBind":"proxy/user-bind",
	"vip":"m/vip/index",
    "orderDetail": "m/order/view",
}

const apiBaseURL = process.env.VUE_APP_BASE_API

export default {
    os,
    appversion,
    lang,
    languages,
    accessToken,
    inWechat,
    inApp,
    apis,
    changeLang,
    cdnUrl,
    ossUrl,
	logoUrl,
    userInfo,
    apiBaseURL,
    version
}